import Err from '@leverege/error'

import { getId } from '../Utils.js'
import RouteUtils from './RouteUtils.js'
import { User } from './authz/index.js'
import { Resource, Resources } from './rsrc/index.js'
import Srv from './Srv.js'
import Rule from './Rule.js'
import Rules from './Rules.js'
import ApiAccessKey from './ApiAccessKey.js'
import ApiAccessKeys from './ApiAccessKeys.js'
import ResourceTemporaryUsers from './temporaryUser/ResourceTemporaryUsers.js'
import ResourceTemporaryUser from './temporaryUser/ResourceTemporaryUser.js'

export default function InterfaceApi( root, sys, type ) {
  
  const id = getId( sys, false )
  if ( id == null || type == null ) {
    throw Err( `invalid system or type. id=${id} type=${type}` )
  }
 
  const connect = RouteUtils.collection( root, `v1/interface/${id}/${type}`, true, true )
  const eventsPath = `v1/interface/${id}/${type}.events`
  const historyPath = `v1/interface/${id}/${type}.history`

  return {
    list : connect.list,
    create : connect.create,
    get : connect.get,
    delete : connect.delete,
    obj( id ) { return createObj( connect, id, root ) },
    getDeviceByNetworkAlias : ( networkId, key, value, opts ) => {
      return getDeviceByNetworkAlias( root, `v1/interface/${id}/${type}`, networkId, key, value, opts )
    },
    model : RouteUtils.collection( root, `v1/interface/${id}/${type}.model`, true, true ).get,
    forwardParent( path, deviceId, opts ) { return RouteUtils.collection( root, `v1/interface/forward/${id}/${type}/*/${path}` ).get( deviceId, opts ) },
    parent( path, deviceId, options ) { return RouteUtils.collection( root, `v1/interface/parent/${id}/${type}/*/${path}` ).get( deviceId, options ) },
    history : ( q, query ) => {
      const api = root.child( historyPath )

      return api.get( { ...query, q : JSON.stringify( q ) } )
    },
    events : () => {
      return {
        list : ( q, query ) => {
          const api = root.child( eventsPath )

          return api.get( { ...query, q : JSON.stringify( q ) } )
        }
      }
    },
    search : root.child( `v1/interface/${id}/${type}.search`, true, true ).post,
    // rules() { return new Rules( connect, false ) },
    // rule( id ) { return new Rule( connect, id ) },

  }
}

function createObj( connect, id, root ) { 
  id = getId( id )
  
  const c = connect.child( id )

  const rtn = {
    get : c.get,
    update : c.patchRaw,
    delete : c.delete,
    create : c.post, 
    grp( path ) { return createGrp( c, path, root ) },
    obj( path ) { return createObj( c, path, root ) },
    srv( alias ) { return new Srv( connect.child( `${id}.srv` ), alias, true ) },
    user( userId ) { return new User( connect.child( `${id}.user/${getId( userId )}` ), null, { noChild : true } ) },
    users() { 
      return RouteUtils.authzUsers( connect.child( `${id}.user` ), null, { noChild : true } )
    },
    temporaryUsers() {
      return new ResourceTemporaryUsers( connect, { childPrefix : id, divider : '.' } )
    },
    temporaryUser( tId ) {
      return new ResourceTemporaryUser( connect, tId, { childPrefix : id, divider : '.' } )
    },
    resource( rsrc ) { return new Resource( connect.child( `${id}.rsrc` ), rsrc, false ) },
    resources() { return new Resources( connect.child( `${id}.rsrc` ), false ) },
    getDeviceByNetworkAlias : ( networkId, key, value, opts ) => {
      return getDeviceByNetworkAlias( connect, id, networkId, key, value, opts )
    },

    model : connect.child( `${id}.model` ).get,
    history : ( q, query ) => connect.child( `${id}.history` ).get( { ...query, q : JSON.stringify( q ) } ),
    events : () => {
      return {
        list : ( q, query ) => connect.child( `${id}.events` ).get( { ...query, q : JSON.stringify( q ) } ),
        // create : options => connect.child( `${id}.event` ).post( options ),
        // ack : ( eventId, data ) => connect.child( `events/${eventId}/ack` ).post( data )
      }
    },
    messages : () => ( {
      send : message => connect.child( `${id}.message` ).post( message )
    } ),
    search : connect.child( `${id}.search` ).post,
    rules() { return new Rules( connect.child( `${id}.rule` ), false, true ) },
    rule( ruleId ) { return new Rule( connect.child( `${id}.rule` ), ruleId, true ) },

    apiAccessKeys() { return new ApiAccessKeys( connect.child( `${id}.apiAccess` ) ) },
    apiAccessKey( apiAccessId ) { return new ApiAccessKey( connect.child( `${id}.apiAccess` ), apiAccessId ) },
  }

  if ( typeof root.interfaceObj === 'function' ) {
    return root.interfaceObj( rtn, c.path )
  }
  return rtn
}

function createGrp( connect, attr, root ) { 
  const c = RouteUtils.collection( connect, attr, false, true )
  const rtn = {
    get : c.get, // get element
    list : c.list, // get all
    create : c.create, // add to list
    update( id, body, opts ) { return this.obj( id ).update( body, opts ) },
    delete : c.delete, // delete an element
    obj( path ) { return createObj( c, path, root ) },
    getDeviceByNetworkAlias : ( networkId, key, value, opts ) => {
      return getDeviceByNetworkAlias( connect, attr, networkId, key, value, opts )
    },
    model : connect.child( `${attr}.model` ).get,
    history : ( q, query ) => connect.child( `${attr}.history` ).get( { ...query, q : JSON.stringify( q ) } ),
    events : () => {
      return {
        list : ( q, query ) => connect.child( `${attr}.events` ).get( { ...query, q : JSON.stringify( q ) } )
      }
    },
    search : connect.child( `${attr}.search` ).post,
  }
  if ( typeof root.interfaceGrp === 'function' ) {
    return root.interfaceGrp( rtn, c.path )
  }
  return rtn
}

function getDeviceByNetworkAlias( connect, id, networkId, key, value, opts ) {
  const nid = typeof networkId === 'object' ? networkId.id : networkId
  const eNid = encodeURIComponent( nid )
  const eKey = encodeURIComponent( key )
  const eVal = encodeURIComponent( value )
  return connect.child( `${id}.deviceByNetworkAlias/${eNid}/${eKey}/${eVal}` ).get( opts )
}
